/** Scoped saved reads only. No refresh or generation endpoint is called by the page. */
import { queryOptions } from '@tanstack/react-query'
import { storeResearchCardsSchema } from '@testfeed/shopify-contracts'
import { shopifyApiClient } from '../shopifyApiClient'
import type { ShopifyTokenSource } from '../shopifyApiFetch'
import { buildShopifyAppScopeKey, shopifyQueryKey, type ShopifyAppContextValue } from '../ShopifyAppContext'
import { throwMerchantFacingApiError } from '../shopifyApiError'
import { parseContractPayload } from '../merchantErrors'

export function researchCardQueryOptions(
  shopify: ShopifyTokenSource,
  scope: ShopifyAppContextValue,
  entitled: boolean,
) {
  const key = buildShopifyAppScopeKey(scope)
  const active = () => !scope.isActiveScope || scope.isActiveScope(key)
  return queryOptions({
    queryKey: shopifyQueryKey(scope.shopDomain, scope.orgId, scope.connectionId, ['research-cards']),
    enabled: Boolean(entitled && scope.orgId && scope.connectionId && active()),
    retry: false,
    gcTime: 0,
    refetchOnWindowFocus: true,
    queryFn: async ({ signal }) => {
      if (!active()) throw new Error('RESEARCH_CARD_SCOPE_CHANGED')
      if (!entitled) throw new Error('RESEARCH_CARD_NOT_ENTITLED')
      const response = await shopifyApiClient(shopify).api['research-cards'].read.$post(
        { json: {} },
        { init: { signal }, headers: { 'X-TestFeed-Integration-Connection-Id': scope.connectionId! } },
      )
      if (!response.ok) await throwMerchantFacingApiError(response, 'research-cards')
      const data = parseContractPayload('research-cards', storeResearchCardsSchema, await response.json())
      if (
        !active() ||
        data.scope.orgId !== scope.orgId ||
        data.scope.connectionId !== scope.connectionId ||
        data.scope.shop !== scope.shopDomain
      )
        throw new Error('RESEARCH_CARD_SCOPE_CHANGED')
      return data
    },
  })
}
